const CirculoIcon = ({ width, height, color, stroke }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg"
            width={width ? width : "24"}
            height={height ? height : "24"}
            viewBox="0 0 24 24" fill={color ? color : "none"} stroke={stroke ? stroke : "currentColor"} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-icon lucide-circle">
            <circle cx="12" cy="12" r="10" />
        </svg>);
};

export default CirculoIcon;